module.exports = __webpack_public_path__ + "media/cancel-button.46feee4a.svg";